import Modal from '@/components/Modal';
import Stack from '@/components/Stack';
import styled from '@/styles';

const ImageContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  maxHeight: '70vh',
  overflow: 'auto',
  padding: '20px',
});

const PreviewImage = styled('img', {
  maxWidth: '100%',
  maxHeight: '70vh',
  objectFit: 'contain',
  borderRadius: '$md',
});

type Props = {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string | null;
  title?: string;
};

const ImagePreviewModal = ({
  isOpen,
  onClose,
  imageUrl,
  title = 'Image Preview',
}: Props) => {
  if (!isOpen || !imageUrl) return null;

  return (
    <Modal
      size="lg"
      title={title}
      wrapperBackground={true}
      onRequestClose={onClose}
    >
      <ImageContainer>
        <Stack align="center" justify="center">
          <PreviewImage src={imageUrl} alt={title} />
        </Stack>
      </ImageContainer>
    </Modal>
  );
};

export default ImagePreviewModal;
